import { Component, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../environments/environment';



@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {

  title = 'default';
  clientId: string = environment.APP_CLIENTID

  onActivate(event:any) {
   window.scroll({ 
           top: 0, 
           left: 0, 
           behavior: 'smooth' 
    });
  }
}
